import React, { Component } from "react";
import $ from "jquery";
import Loader from "../components/loader";

// import QuestionRow from "../components/questionRow";
// import AnswerLine from "../components/answers/answer_line";
// import CommentLine from "../components/comments/comment_line";
import { getQuestion } from "../helper/question_helper";
import { renderErrorMessage } from "../helper/user_helper";

import ListQuestion from "../components/list/interface/list_question";
import ListComment from "../components/list/interface/list_comment";
import ListAnswerRow from "../components/list/interface/list_answer_row";
import { getUser } from "../helper/user_helper";

import MetaTags from "react-meta-tags";

class Question extends Component {
  state = {
    questionId: null,
    loaded: false,
    answers: [],
    question: null,
    errors: "",
    showComment: false,
    current_page: 1
  };

  constructor(props) {
    super(props);
    this.state = {
      questionId: props.match.params.id,
      answers: [],
      loaded: false,
      question: null,
      errors: "",
      showComment: false,
      current_page: 1,
      can_load_more: true,
      user: null
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.getQuestionPage(this.state.current_page);
    this.refContainer.addEventListener("scroll", this.handleScroll);
    const self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        self.setState({ signedIn: true, user: answer.user });
      }
    });
  }

  componentWillUnmount() {
    if (this.getListCall) {
      this.getListCall.cancel();
    }
    if (this.questionCall) {
      this.questionCall.cancel();
    }
    this.refContainer.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    if (this.state.can_load_more === false) {
      // Checking if we are not already loading more data
      return;
    }
    if (this.state.current_page >= this.state.total_pages) {
      // We don't check anything if questions doesn't have other questions
      //return;
    }
    if (
      $("#question").scrollTop() + $("#question").innerHeight() >=
      $("#question")[0].scrollHeight
    ) {
      // Load More questions
      this.setState({ can_load_more: false });
      const current_page = this.state.current_page + 1;
      this.setState({ current_page });
      this.getQuestionPage(this.state.current_page);
    } else {
      // Nothing
    }
  }

  render() {
    return (
      <div
        id="question"
        className="center allow_scroll page_top_nav"
        ref={ref => {
          this.refContainer = ref;
        }}
      >
        {/* {this.renderMeta()} */}
        {renderErrorMessage(this.state.errors)}
        {this.renderQuestion()}
      </div>
    );
  }

  renderMeta() {
    if (this.state.question) {
      return (
        <MetaTags>
          <title>{this.state.question.name}</title>
          <meta property="og:title" content="Yaystack" />
        </MetaTags>
      );
    }
    return <div />;
  }

  renderQuestion() {
    if (this.state.question == null) {
      return (
        <div className="">
          <Loader loaded={this.state.loaded} />
        </div>
      );
    }

    const self = this;
    var answer = this.state.answers.map(function(answer) {
      return (
        <ListAnswerRow
          key={answer.id}
          answer={answer}
          row={true}
          removeAnswer={self.removeAnswer}
          updateAnswer={self.updateAnswer}
        />
      );
    });

    return (
      <div className="profilePage list center list_one_navbar">
        <div className="max_width_500">
          <Loader loaded={this.state.loaded} />
          <ListQuestion
            question={this.state.question}
            showAnswer={true}
            onClick={this.openQuestion}
            row={true}
            link={true}
          />
          {answer}
          <ListComment
            question={this.state.question}
            addAnswer={this.addAnswer}
            user={this.state.user}
          />
        </div>
      </div>
    );
  }

  addAnswer = (answer, _question) => {
    const answers = this.state.answers;
    answers.push(answer);
    const question = this.state.question;
    question.already_comment = true;
    this.setState({
      answers,
      question
    });
  };

  removeAnswer = answer => {
    var answers = [...this.state.answers];
    for (var answer_id in answers) {
      if (answers[answer_id].id === answer.id) {
        answers.splice(answer_id, 1);
        break;
      }
    }
    this.setState({ answers });
  };

  updateAnswer = answer => {
    console.log("answer");
    console.log(answer);
    var answers = [...this.state.answers];
    console.log(answers);
    for (var answer_id in answers) {
      console.log(answer_id);
      if (answers[answer_id].id === answer.id) {
        answers[answer_id] = answer;
        console.log("ab");
        break;
      }
    }
    console.log("set");
    this.setState({ answers });
  };

  getQuestionPage(page) {
    const self = this;
    this.questionCall = getQuestion(this.state.questionId, page);
    this.questionCall.promise.then(answer => {
      const question = answer.question;
      const answers = self.state.answers.concat(answer.answers);
      const total_pages = answer.total_pages;
      const loaded = answer.loaded;
      const errors = answer.errors;
      self.setState({ question, answers, total_pages, loaded, errors });
    });
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/pages/question.jsx